import gql from "graphql-tag";

export const List = gql`
query Workshops {
  listMyWorkshops {
    items {
      workshopId
      userId
      event {
        title
      }
      competition {
        date
        i18n_title
      }
      userData
    }
  } 
}
`;

export const Get = gql`
query GetMyWorkshop($workshopId: ID!) {
  getMyWorkshop(workshopId: $workshopId) {
    workshopId
    userId
    event {
      id
      title
    }
    competition {
      id: competitionId
      title: i18n_title
    }
    hasAcceptedCompetitionRules
    userData
    previousExperience
    informationSource
  }
}
`;


export const ListEvents = gql`
query listEvents {
  listEvents {
      value: id
      text: title
      location
      registrationEnabled
      type
      competitions {
        id: competitionId
        code
        date
        beginTime
        endTime
        organizer
  	competitionRulesURL 
     	teamMemberLimit
        participantLimit
        participantCount
      	robotRequired
      	published
        difficulty
        i18n_title
        i18n_description
      }
    }
}
`;

export const Create = gql`
  mutation CreateMyWorkshop($input: CreateMyWorkshopInput!) {
    createMyWorkshop(input: $input) {
      competitionId
      eventId
      hasAcceptedCompetitionRules
      userData
      previousExperience
      informationSource
    }
  }
`;

export const Update = gql`
  mutation UpdateMyWorkshop($input: UpdateMyWorkshopInput!) {
    updateMyWorkshop(input: $input) {
      workshopId
      competitionId
      eventId
      hasAcceptedCompetitionRules
      userData
      previousExperience
      informationSource
    }
  }
`;

export const Delete = gql`
  mutation DeleteMyWorkshop($workshopId: ID!) {
    deleteMyWorkshop(workshopId: $workshopId) {
      workshopId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/user/containers/Workshops/graphql.js